import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "../sudokit/components/Dialog";

// Keep this explanation aligned with shared/adminPermissions and adminAccess/policy.
const COMPARISONS = [
  [
    "Account and billing support",
    "Look up customers; update email, name, Discord ID and settings; manage subscriptions, trials and credits; revoke sessions; manage notes and email preferences; moderate shared documents.",
    "All Support tools.",
  ],
  ["Activity history", "View one customer’s activity history.", "Also view global admin activity logs."],
  ["Metadata", "View document, project, cardset, completion, chat and invocation metadata. Content is excluded from these admin views.", "View the same metadata."],
  [
    "Content in admin tools",
    "No direct access to writing, prompts, completions, chat content or invocation content.",
    "Read document, project and cardset content, prompts, completions, chats and invocations.",
  ],
  ["Full project export", "Not allowed.", "Allowed, including project structure and series exports."],
  [
    "Become / sign-in links",
    "May impersonate customers. Cannot impersonate or perform targeted support actions on accounts assigned either Support or Admin.",
    "May impersonate customers and accounts assigned Support or Admin.",
  ],
  [
    "Role management and other admin tools",
    "Cannot assign, change or remove roles, or use Admin-only operational tools.",
    "May assign, change and remove roles, and use all other admin tools. The last Admin cannot be removed or demoted.",
  ],
];

export function AdminRolesHelp() {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <button
          type="button"
          className="mt-3 cursor-pointer border-0 bg-transparent p-0 text-sm text-app-primary-cta-high-contrast underline underline-offset-2"
        >
          Learn about the roles
        </button>
      </DialogTrigger>
      <DialogContent className="max-h-[85vh] max-w-4xl overflow-y-auto text-app-grey-0">
        <DialogHeader>
          <DialogTitle>Admin and Support roles</DialogTitle>
          <DialogDescription>Admin includes every Support capability, plus content access, exports, role management and operational tools.</DialogDescription>
        </DialogHeader>
        <div className="mt-4 overflow-x-auto">
          <table className="w-full min-w-[560px] border-collapse text-left text-sm">
            <thead>
              <tr>
                {["Capability", "Support", "Admin"].map((label) => (
                  <th
                    key={label}
                    scope="col"
                    className="p-3 align-top"
                  >
                    {label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {COMPARISONS.map(([label, support, admin]) => (
                <tr
                  key={label}
                  className="border-t border-solid border-app-divider"
                >
                  <th
                    scope="row"
                    className="p-3 align-top font-medium"
                  >
                    {label}
                  </th>
                  <td className="p-3 align-top">{support}</td>
                  <td className="p-3 align-top">{admin}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p className="mb-0 mt-4 text-sm text-app-grey-1">
          Impersonation is different from direct admin content access: both roles can see the customer’s content while acting as that customer. Impersonation sessions carry no admin permissions.
        </p>
      </DialogContent>
    </Dialog>
  );
}
